import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const Responsibility = ({ slot }) => {
	const { type, data, layout } = slot[0];
	return (
		<Layout>
			<Slot
				top={5}
				left={5}
				width={35}
				height={15}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={5}
				left={45}
				width={20}
				height={15}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={25}
				left={5}
				width={60}
				height={70}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={5}
				left={70}
				width={25}
				height={90}
				component={type}
				data={data}
				layout={layout}
			/>
		</Layout>
	)
}

Responsibility.defaultProps = {
	slot: []
}

Responsibility.propTypes = {
	slot: PropTypes.array,
}

export default Responsibility;
